const CLOSED_BY_DONT_SHOW_IT_AGAIN = 'CLOSED_BY_DONT_SHOW_IT_AGAIN';
const ONLY_ONE_CHILD = Symbol('ONLY_ONE_CHILDE');
function createClosedByDontShowAgainEvent(id, dontShowAgainId) {
    return { type: CLOSED_BY_DONT_SHOW_IT_AGAIN, id, dontShowAgainId };
}
function isClosedByDontShowAgainEvent(event) {
    return event && event.type === CLOSED_BY_DONT_SHOW_IT_AGAIN;
}

export { CLOSED_BY_DONT_SHOW_IT_AGAIN, ONLY_ONE_CHILD, createClosedByDontShowAgainEvent, isClosedByDontShowAgainEvent };
